<template>
  <v-container>
    <v-card class="orange lighten-5" elevation="3">
      <v-card-title v-if="deliveryMethod.id" class="white--text orange">{{
        deliveryMethod.name
      }}</v-card-title>
      <v-card-title v-else class="white--text orange"
        >Ny leveringsmetode</v-card-title
      >

      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="deliveryMethod.name"
                label="Navn"
                :rules="[rules.required]"
                :disabled="isSaving || isLoading"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="deliveryMethod.description"
                label="Beskrivelse"
                :disabled="isSaving || isLoading"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="deliveryMethod.price"
                label="Pris"
                type="number"
                :rules="[rules.required]"
                :disabled="isSaving || isLoading"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-select
                v-model="deliveryMethod.vat_class"
                :items="vatClasses"
                item-value="id"
                label="Momsklasse"
                single-line
                required
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.name }} ({{ data.item.percentage }}%)
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item.name }} ({{ data.item.percentage }}%)
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <v-checkbox
                v-model="deliveryMethod.requires_delivery_address"
                label="Krever leveringsadresse"
                :disabled="isSaving || isLoading"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn
            type="submit"
            :disabled="isLoading || isSaving"
            :loading="isSaving"
            color="success"
          >
            <v-icon left> mdi-content-save </v-icon>
            Lagre
          </v-btn>

          <v-spacer />

          <v-btn color="error" @click="deleteDeliveryMethod">
            <v-icon left> mdi-delete </v-icon>
            Slett
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "AdminDeliveryMethodForm",

  props: {
    vatClasses: {
      required: true,
      type: Array,
    },
    deliveryMethod: {
      required: false,
      default: () => {
        return {
          id: null,
          name: "",
          description: "",
          requires_delivery_address: false,
        };
      },
      type: Object,
    },
  },

  data() {
    return {
      isSaving: false,
      isLoading: false,
      rules: {
        required: (v) => !!v || "Dette feltet er påkrevd.",
      },
    };
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organization.id;
    },
  },

  methods: {
    async deleteDeliveryMethod() {
      this.isSaving = true;
      await backend.del(
        `deliverymethods/${this.deliveryMethod.id}/`,
        {},
        { organization: this.deliveryMethod.organization }
      );

      this.isSaving = false;
      this.$store.dispatch("add", {
        type: "success",
        message: "Leveringsmetoden har nå blitt slettet.",
      });

      this.$emit("update:delivery-methods");
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;

        if (this.deliveryMethod.id) {
          await backend.put(
            `deliverymethods/${this.deliveryMethod.id}/`,
            this.deliveryMethod,
            {
              organization: this.organizationId,
            }
          );
        } else {
          this.deliveryMethod.organization = this.organizationId;
          await backend.post(`deliverymethods/`, this.deliveryMethod, {
            organization: this.organizationId,
          });
        }

        this.$store.dispatch("add", {
          type: "success",
          message: "Leveringsmetoden har nå blitt lagret.",
        });

        this.isSaving = false;

        this.$emit("update:delivery-methods");

        // Reset our form
        if (!this.deliveryMethod.id) {
          this.deliveryMethod.name = "";
          this.deliveryMethod.description = "";
          this.deliveryMethod.price = "";
          this.deliveryMethod.vat_class = "";
          this.deliveryMethod.requires_delivery_address = false;
        }
      }
    },
  },
};
</script>
